var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgZitatZeichen = function SvgZitatZeichen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 49,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.4 48.2 0 43.6q5-4 8.4-8.8 3.6-4.6 3.6-9.4 0-2.8-1-3.6-1-1-2.6-2.2-2.2-1.2-4-3.4t-1.8-6Q2.6 6 5.4 3q3-3 7.4-3 5 0 8.8 4.2t3.8 12.6q0 6.6-2.8 12.4-2.8 6-7.8 10.8T3.4 48.2m30.6 0-3.4-4.6q5-4 8.4-8.8 3.6-4.6 3.6-9.4 0-2.8-1-3.6-1-1-2.6-2.2-2.2-1.2-4-3.4t-1.8-6Q33.2 6 36 3q3-3 7.4-3 5 0 8.8 4.2T56 16.8q0 6.6-2.8 12.4-2.8 6-7.8 10.8T34 48.2"
  })));
};
export default SvgZitatZeichen;